import React from 'react';

import {
    Heading,
    Box,
    HStack,
    Stack,
    Divider,
    ResponsiveValue,
    Text,
    useMediaQuery,
} from '@chakra-ui/react';
import { StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import { usePathname } from 'next/navigation';

import checkCircle from '@assets/check-circle.svg';
import { CustomText } from '@components/Custom-text';

type HowItWorksProps = {
    stepNumber: string;
    heading: string;
    text: string;
    bullets: Array<string>;
    imageSrc: string | StaticImport;
    backgroundImage: string;
    direction: ResponsiveValue<'row' | 'column' | 'row-reverse' | 'column-reverse'> | undefined;
};
export const HowItWorksStepOne = ({
    stepNumber,
    heading,
    text,
    bullets,
    imageSrc,
    backgroundImage,
    direction,
}: HowItWorksProps) => {
    const pathname = usePathname();
    const isHome = pathname === '/';

    const [isLargerThanMd] = useMediaQuery('(min-width: 768px)');

    return (
        <HStack
            py={{ base: 5, sm: 5, md: 14 }}
            px={{ base: 0, sm: 0, md: 14 }}
            borderWidth={1}
            borderColor={isHome ? 'border' : 'white'}
            borderRadius={18}
            justifyContent="space-between"
            flexDirection={direction}
            mb={4}
            mt={2}
        >
            <Stack spacing={2} alignItems="flex-start" maxWidth={{ base: '80%', md: '500px' }}>
                <Heading size="md" color="primary.dark">
                    {' '}
                    Step {stepNumber}
                </Heading>
                <Text
                    color="primary.light"
                    fontWeight="medium"
                    fontSize="30px"
                    lineHeight="36px"
                    fontFamily="Rubik"
                >
                    {heading}
                </Text>
                <CustomText color="shadowSlate" size="lg">
                    {text}
                </CustomText>
                <Box py={{ base: '1', md: '4' }}>
                    <Divider orientation="horizontal" w={{ base: '100%', md: 500 }} />
                </Box>

                {bullets.map((bullet, index) => (
                    <Box
                        key={index}
                        gap={2}
                        display="flex"
                        justifyItems="center"
                        alignItems="center"
                    >
                        <img src={checkCircle.src} alt="icon" width={20} height={20} />
                        <Box flex={1}>
                            <CustomText color="primary.dark" size="md">
                                {bullet}
                            </CustomText>
                        </Box>
                    </Box>
                ))}
            </Stack>

            <HStack
                backgroundColor={backgroundImage}
                px={{ base: 2, md: 12 }}
                pt={{ base: 2, md: 12 }}
                borderRadius={10}
                w={{ base: '80%', md: '52%' }}
                height={{ md: 330 }}
                position={{ md: 'relative' }}
            >
                <Image
                    src={imageSrc}
                    alt="background image of howitworks"
                    style={
                        isLargerThanMd
                            ? {
                                  position: 'absolute',
                                  bottom: 0,
                                  left: '48px',
                                  right: '48px',
                                  marginLeft: 'auto',
                                  marginRight: 'auto',
                                  width: 'auto',
                                  maxWidth: 'calc(100% - 96px)',
                                  height: 280,
                              }
                            : undefined
                    }
                />
            </HStack>
        </HStack>
    );
};
